import React from 'react';
import BackToTop from './BackToTop';
import DialogLink from './DialogLink';

const FooterInfo = () => {
	return (
		<div className="row text-center text-sm-left bg-white mx-0 py-6">
			<div className="col-xs-12 px-0">
				<div className="text-center">
					<DialogLink
						pageAlias="WS_STL_FAQ_FRAGMENT"
						dataContent="FREQUENTLY_ASKED_QUESTIONS"
						dataTitle="FREQUENTLY_ASKED_QUESTIONS"
						linkLabel="FAQS"
					/>
					<span className="text-bold text-primary-500">|</span>
					<DialogLink
						pageAlias="WS_STL_TERMS_AND_CONDITIONS_FRAGMENT"
						dataContent="WS_STL_TERMS_AND_CONDITIONS"
						dataTitle="WS_STL_TERMS_AND_CONDITIONS"
						linkLabel="WS_STL_TERMS_AND_CONDITIONS"
					/>
				</div>
				<BackToTop />
			</div>
		</div>
	);
};

export default FooterInfo;
